module.exports = __webpack_public_path__ + "assets/2f6305fc347770f9bc867a0dc6a5212e.png";